import React, { useState } from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

interface IAddDictionaryTileProps {
  onClick: () => void;
}

const AddDictionaryTile: React.FC<IAddDictionaryTileProps> = ({ onClick }) => {
  const [hover, setHover] = useState(false);

  return (
    <ButtonBase
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      sx={(theme) => ({
        alignItems: 'center',
        background: hover
          ? theme.palette.mode === 'light'
            ? 'rgba(59, 44, 147, 0.06)'
            : 'rgba(155, 124, 255, 0.10)'
          : 'transparent',
        border: '2px dashed',
        borderColor: hover ? 'primary.main' : 'primary.tableBorder',
        borderRadius: 2,
        color: hover ? 'primary.main' : 'text.secondary',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        gap: 1.25,
        justifyContent: 'center',
        minHeight: 168,
        p: 2.25,
        textAlign: 'center',
        transition: 'all .18s ease',
        width: '100%',
      })}
    >
      <Box
        sx={{
          alignItems: 'center',
          bgcolor: hover ? 'primary.main' : 'background.default',
          borderRadius: '50%',
          color: hover ? 'primary.contrastText' : 'text.secondary',
          display: 'inline-flex',
          height: 46,
          justifyContent: 'center',
          transition: 'all .18s ease',
          width: 46,
          '& svg': {
            color: hover ? '#fff' : 'inherit',
          },
        }}
      >
        <AddIcon sx={{ fontSize: 26 }} />
      </Box>
      <Typography sx={{ fontSize: 15, fontWeight: 600 }}>
        {'Створити словник'}
      </Typography>
      <Typography sx={{ fontSize: 13, maxWidth: 200 }}>
        {'Свій набір слів під тему, роботу чи серіал'}
      </Typography>
    </ButtonBase>
  );
};

export default AddDictionaryTile;
